import { CircularProgress, InputBase, Button } from "@mui/material";


export default function NewSchemaCreation({ loadAddingSchema, schemaLoader, addingSchema, setNewSchema, newSchema, setAddingSchema, createSchema, setError }) {
    return(
        <>
            <CircularProgress
                sx={{
                    display: loadAddingSchema ? "flex" : "none",
                    margin: "auto",
                    color: "#linear-gradient(90deg, #118EA0 0%, #50C9DB 100%)"
                }}
            />
            <div
                style={{
                    display: addingSchema && !schemaLoader && !loadAddingSchema ? "flex" : "none",
                    flexDirection: "column"
                }}
            >
                <InputBase
                    sx={{
                        backgroundColor: "#040417",
                        color: "#fff",
                        borderRadius: "9px",
                        pl: "10px",
                        width: "100%",
                        margin: "4px auto auto 0px",
                        border: "1px solid #fcfcfc"
                    }}
                    placeholder="New Schema Name"
                    onChange={(e) => setNewSchema(e.target.value.replace(/[^a-zA-Z0-9_ ]/g, '').replace(" ", "_").replace(/^[^a-zA-Z]/, ''))}
                    value={newSchema}
                    inputProps={{
                        autoCorrect: "off"
                    }}
                />
                <div style={{ display: "flex"}}>
                    <Button
                        fullWidth
                        onClick={() => setAddingSchema(false)}
                        sx={{
                            color: "#fff",
                            textTransform: "none",
                            backgroundColor: "#118EA0",
                            margin: "10px 5px 0px 0px",
                            borderRadius: "12px",
                            "&:hover": {backgroundColor: "#333333"}
                        }}
                    >
                        Cancel
                    </Button>
                    <Button
                        fullWidth
                        onClick={newSchema !== "" ? createSchema : () => setError("Schema name must not be blank.")}
                        sx={{
                            color: "#fff",
                            textTransform: "none",
                            backgroundColor: "#118EA0",
                            margin: "10px 5px 0px 0px",
                            borderRadius: "12px",
                            "&:hover": {backgroundColor: "#333333"}
                        }}
                    >
                        Confirm
                    </Button>
                </div>
            </div>
        </>
    )
}